import React from 'react';
import { IProps, IState } from 'containers/Signup/types';
import StepBar from 'components/StepBar';
import SliderBoundless from 'components/SliderBoundless';

import ReviewTerms from 'components/Signup/ReviewTerms';
import MemberProfile from 'components/Signup/MemberProfile';
import MemberProfileList from 'components/Signup/MemberProfileList';
import OTPVerification from 'components/Signup/OTPVerification';
import SignupComplete from 'components/Signup/SignupComplete';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setCaptchaErrorModalVisibleAction, setCaptchaSendModalVisibleAction, setCaptchaReturnModalVisibleAction } from 'redux/actions/modal.action';
import { SignupStep } from 'constants/enums/signupStep.enum';
import { AddFavoriteItem, MemberProfile as MemberProfileModel } from 'bff/models/member';
import service from 'bff/services/signupService';
import apiCommonService from 'bff/services/commonService';
import { OTPInfo, LogInInfo } from 'bff/models/login';
import _ from 'lodash';
import { Activity, NotifyEmail } from 'bff/models/info';
import sweetAlertService from 'utils/sweetAlertService';
import { SactionType } from 'constants/enums/sactionType.enum';
import environment from 'constants/environments';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { NotifyType } from 'constants/enums/notifyType.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';
import { RootReducersState } from 'redux/reducers';
import { fetchMyFavorite } from 'redux/actions/components/myFavorite.action';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { logOut } from 'redux/actions/components/member.action';
import { ReviewTermsFormValue } from 'components/Signup/ReviewTerms/types';
import { DataLayerArgs } from 'react-gtm-module';
import { pushGTM } from 'plugins/gtmService';
import { MemberPartnerReq, MemberPartnerResp } from 'bff/models/member/memberPartner';

/** 初始化會員資料 */
const initMemberProfile: MemberProfileModel = {
  MEMBER_ID: '',
  GENDER: '',
  NAME: '',
  BIRTHDAY: '',
  MOBILE: '',
  EMAIL_ADDR: '',
  HEARING_DISABILITY: '',
  SECQUE_ID: '',
  SECQUE_QUESTION: '',
  SECQUE_ANSWER: '',
  NATIONALITY_ID: '',
  NATIONALITY_TYPE: '',
  MEMBERSHIP: [],
  HOME_TEL_AREA_CODE: '',
  HOME_TEL_NUMBER: '',
  ADDRESS: '',
  AREA_ID: '',
  AREA_NAME: '',
  CITY_ID: '',
  CITY_NAME: '',
  HOME_TELNO: '',
  MARRIAGE: '',
  OCCUPATION_DESC: '',
  OCCUPATION_DOMAIN_ID: '',
  OCCUPATION_DOMAIN_ID_NAME: '',
  OCCUPATION_ID: '',
  OCCUPATION_ID_NAME: '',
  POST_CODE: ''
};

const initState: IState = {
  secques: [],
  nationalitys: [],
  occupations: [],
  postcodes: [],
  emailDomains: [],
  activeStep: SignupStep.ConsentNotice,
  memberProfile: { ...initMemberProfile },
  UICode: [],
  activities: {
    MORE_ACTIVITY_URL: '',
    ACTIVITY: []
  },
  fetchOTPCount: 0,
  originalUrl: '',
  applicationId: undefined,
  lineBindingStatus: undefined,
  lineUID: undefined
};

class Signup extends React.Component<IProps, IState> {
  state: IState = initState;

  componentDidMount = async () => {
    const { response, lineUID } = await this.verifyAppIdFromQs();
    const appIdObj = response;
    if (this.props.fetchFavoriteComplete) {
      this.props.history.push(RouterSettings.Home);
    }

    let originUrlVal = '';
    if (this.props.history.location.state) {
      const { originUrl }: any = this.props.history.location.state;
      originUrlVal = originUrl || '';
    }

    const initSettingRes = await service.fetchInitSetting(appIdObj?.APPID);
    this.setState({
      secques: [...initSettingRes.secques],
      nationalitys: [...initSettingRes.nationalitys],
      occupations: [...initSettingRes.occupations],
      postcodes: [...initSettingRes.postcodes],
      emailDomains: [...initSettingRes.emailDomains],
      UICode: [...initSettingRes.UICode],
      activities: { ...initSettingRes.activities },
      originalUrl: originUrlVal,
      applicationId: appIdObj?.APPID,
      lineUID: lineUID || undefined
    });
  }

  async verifyAppIdFromQs () {
    storageService.removeItem(storageKeys.ApplicationId);
    storageService.removeItem(storageKeys.LineUID);
    // 取得路徑參數 Appilcation Id
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const applicationId = urlParams.get('ApplicationId');
    const lineUID = urlParams.get('uid');

    if (lineUID) {
      storageService.setItem(storageKeys.LineUID, lineUID);
    }

    if (applicationId) {
      const args: MemberPartnerReq = {
        APPID: applicationId
      };
      const response = await service.checkApplicationId(args);
      // 若此應用系統代號為合法, 則緩存至 sessionStorage，以利後續會員註冊流程
      if (response) {
        storageService.setItem(storageKeys.ApplicationId, JSON.stringify(response));
        return { response, lineUID };
      }
    }
    return { response: undefined, lineUID };
  }

  componentDidUpdate () {
    commonService.scrollToTop();
    // // console.log('res', this.props.nationalitys);
    // console.log('Signup componentDidUpdate');
  }

  componentWillUnmount () {
    this.setState({ ...initState });
  }

  /**
   * @description 切換進行中的註冊階段
   */
  handleSetActiveStep = (step: SignupStep) => {
    this.setState({
      activeStep: step
    });
  }

  /**
   * @description 條款頁確認
   */
  handleReviewTermsSubmit = (formVal: ReviewTermsFormValue) => {
    this.setState({
      activeStep: SignupStep.FillInMember,
      previewTermsFormVal: { ...formVal }
    });
  }

  /**
   * @description 暫存 會員註冊 step2 的會員資料
   */
  handleSetMemberProfile = async (memberProfile: MemberProfileModel) => {
    this.setState({
      activeStep: SignupStep.PreviewMemberInfo,
      memberProfile: {
        ...memberProfile,
        EDM_SUBSCRIBE_TIME: this.state.previewTermsFormVal?.AGGREE_RECEIVE_PRODUCT_INFO_TIME
      },
      fetchOTPCount: 0
    });
  };

  /**
   * @description 清除暫存的會員基本資料
   */
  handleResetTempMemberProfile = () => {
    this.setState({
      activeStep: SignupStep.ConsentNotice,
      memberProfile: { ...initMemberProfile }
    });
  }

  /**
   * @description 會員資料註冊 取得 OTP 驗證碼方法
   * @param memberProfile 會員資料
   */
  handleFetchOTP = async (memberProfile: MemberProfileModel) => {
    // 判斷是否已檢核 3 次
    if (this.state.fetchOTPCount + 1 > 3) {
      this.handleOTPLimit();
      return;
    }

    const result = await apiCommonService.fetchOTP(memberProfile, SactionType.Signup, false, this.state.applicationId);
    if (result) {
      this.setState({
        activeStep: SignupStep.OTPVerification,
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime()
      });
    }
  };

  /**
   * @description 會員資料註冊 重新取得 OTP 驗證碼方法
   */
  handleResentOTP = async () => {
    const result = await apiCommonService.fetchOTP(this.state.memberProfile, SactionType.Signup, true, this.state.applicationId);
    if (result) {
      this.setState({
        otpInfo: { ...result.TRANRS }
      });
    }
  };

  /**
   * @description 會員資料註冊 step 3 驗證 OTP認證碼
   * @param otpVerificationReq OTP 驗證頁 Request Model
   */
  handleVerifyOTP = async (otpCode: string) => {
    const otpCount = this.state.fetchOTPCount += 1;

    if (otpCount <= 3) {
      const result = await apiCommonService.verifyOTP(this.state.otpInfo as OTPInfo, otpCode, SactionType.Signup, false, this.state.applicationId);
      // console.log('VerifyOTP Result', result);
      if (typeof result === 'string' && otpCount >= environment.loginCount) {
        this.handleOTPLimit();
        return;
      }

      if (typeof result === 'string') {
        // sweetAlertService.modal({
        //   icon: SweetAlertIcon.Info,
        //   html: '驗證碼輸入錯誤' // 'OTP驗證失敗',
        //   // html: result
        // });
        this.setState({
          fetchOTPCount: otpCount
        });
        return;
      }

      if (result) {
        const memberProfileWithLine = {
          ...this.state.memberProfile,
          LINE_UID: this.state.lineUID
        };
        const insertResult = await service.insertMemberProfile(memberProfileWithLine, this.state.applicationId);

        if (insertResult && Object.keys(insertResult).length > 0) {
          const notifyEmailReq: NotifyEmail = {
            EMAIL_ADDR: this.state.memberProfile.EMAIL_ADDR,
            NOTIFY_TYPE: NotifyType.NREG,
            NOTIFY_DATA: {
              OTP_CODE: '',
              OTP_VALID: `${this.state.otpInfo ? (+this.state.otpInfo.VALIDITY / 60) : 0}` || '',
              MEMBER_NAME: this.state.memberProfile.NAME,
              APPLY_NO: ''
            }
          };

          await apiCommonService.notifyEmail(notifyEmailReq, this.state.applicationId);

          storageService.removeItem(storageKeys.MemberId);
          storageService.removeItem(storageKeys.LoginInfo);
          commonService.storageData(storageKeys.MemberId, this.state.memberProfile.MEMBER_ID);
          commonService.storageData(storageKeys.LoginInfo, insertResult.MEMBER[0]);

          let addFavoriteItem;
          if (this.props.unloginAddItem.InsTypeId && this.props.unloginAddItem.PlanId && this.props.unloginAddItem.ProdId) {
            addFavoriteItem =
              commonService.getAddFavoriteItem(this.props.unloginAddItem.InsTypeId, this.props.unloginAddItem.ProdId, this.props.unloginAddItem.PlanId);
          }

          this.props.onFetchMyFavorite(this.state.memberProfile.MEMBER_ID, addFavoriteItem);

          this.setState({
            activeStep: SignupStep.SignupComplete,
            lineBindingStatus: insertResult.MEMBER[0].LINE_BINDING
          });

          pushGTM(this.getGtmArg('register'));
        }
        return;
      }
    }

    this.handleOTPLimit();
  };

  handleOTPLimit = () => {
    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      // title: '驗證碼輸入有誤'// 'OTP驗證失敗',
      html: '很抱歉，驗證碼輸入錯誤超過三次，請重新註冊，謝謝您！'
    }).then(res => {
      if (res.value) {
        this.setState({
          activeStep: SignupStep.FillInMember
        });
      }
    });
  }

  /**
   * @description 建立註冊完成頁的 Banner 區塊
   */
  handleCreateBanner = () => {
    let childs;
    let bannerArea;
    if (this.state.activities.ACTIVITY.length > 0) {
      childs = _.map(this.state.activities.ACTIVITY, (activity: Activity, index: number) => {
        return (
          <SliderBoundless.Item key={index}>
            <a href={activity.ACTIVITY_URL} rel="noopener noreferrer">
              <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} />
            </a>
          </SliderBoundless.Item>
        );
      });
      bannerArea = (
        <SliderBoundless name="signup__slider">
          {childs}
        </SliderBoundless>
      );
    }

    return (
      <div>
        {bannerArea}
      </div>
    );
  }

  /**
   * @description 投保完成頁 返回事件
  */
  handleSignupCompleteGoBack = (checkCallback: boolean) => {
    const appIdObj: MemberPartnerResp | undefined = JSON.parse(storageService.getItem(storageKeys.ApplicationId));
    if (appIdObj && appIdObj.CBURL && checkCallback) {
      storageService.removeItem(storageKeys.ApplicationId);
      // 組合網址並原頁跳轉過去
      const url = new URL(appIdObj.CBURL);
      const searchParams = new URLSearchParams(url.search);
      searchParams.append('RR', 'SUCCESS');
      window.open(url.href.replace(url.search, '') + '?' + searchParams.toString(), '_self');
      return;
    }
    const originalUrl = this.state.originalUrl;
    if (originalUrl && originalUrl.indexOf('/insure-process') !== -1) {
      this.props.history.replace(originalUrl);

      return;
    }

    this.props.history.replace(RouterSettings.Home);
  }

  getGtmArg = (event:string): DataLayerArgs => {
    // 取得userID
    const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
    return {
      dataLayer: {
        event: 'td_register',
        UserID: loginInfo.sub
      }
    };
  }

  render () {
    // const { location } = this.props;
    // const step = new URLSearchParams(location.search).get('step');
    // // console.log(step);
    let activePageElement;
    let bannerArea;
    switch (this.state.activeStep) {
      case SignupStep.SignupComplete:
        activePageElement = (
          <SignupComplete
            onGoBack={this.handleSignupCompleteGoBack}
            originalUrl={this.state.originalUrl}
            lineBindingStatus={this.state.lineBindingStatus}
          />
        );
        bannerArea = this.handleCreateBanner();
        break;
      case SignupStep.OTPVerification:
        activePageElement = <OTPVerification
          memberId={this.state.memberProfile.MEMBER_ID}
          otpInfo={this.state.otpInfo as OTPInfo}
          getOTPTime={this.state.getOTPTime as number}
          UICode={this.state.UICode}
          onVerifyOTP={this.handleVerifyOTP}
          onResentOTP={() => this.handleResentOTP()}
          memberProfile={this.state.memberProfile}
          onGoBack={() => this.handleSetActiveStep(SignupStep.PreviewMemberInfo)}
          onGoFillInMember={() => this.handleSetActiveStep(SignupStep.FillInMember)}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case SignupStep.PreviewMemberInfo:
        activePageElement = <MemberProfileList
          onGoBack={() => this.handleSetActiveStep(SignupStep.FillInMember)}
          onFetchOTP={this.handleFetchOTP}
          memberProfile={this.state.memberProfile}
          UICode={this.state.UICode}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case SignupStep.FillInMember:
        activePageElement = <MemberProfile
          secques={this.state.secques}
          nationalitys={this.state.nationalitys}
          occupations={this.state.occupations}
          postcodes={this.state.postcodes}
          emailDomains={this.state.emailDomains}
          memberProfile={this.state.memberProfile}
          UICode={this.state.UICode}
          onGoBack={() => this.handleResetTempMemberProfile()}
          onFormSubmit={this.handleSetMemberProfile}
          applicationId={this.state.applicationId}

        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
      case SignupStep.ConsentNotice:
      default:
        activePageElement = <ReviewTerms
          onGoBack={() => this.props.history.goBack()}
          onNextStep={this.handleReviewTermsSubmit}
          UICode={this.state.UICode}
          applicationId={this.state.applicationId}
        // eslint-disable-next-line react/jsx-closing-bracket-location
        />;
        break;
    }

    return (
      <div className="signup">
        <div className="template-container">
          <div className="template-content">
            <div className="signup__section">
              <StepBar activeStep={this.state.activeStep} />
            </div>
            {activePageElement}
          </div>
        </div>

        {/* 註冊完成頁的 Banner 區塊 */}
        {bannerArea}

        {
          /*
            <button onClick={() => this.props.setCaptchaErrorModalVisible(true)}>驗證碼錯誤 剩餘 3 次機會</button>
            <button onClick={() => this.props.setCaptchaSendModalVisible(true)}>已發送驗證號碼</button>
            <button onClick={() => this.props.setCaptchaReturnModalVisible(true)}>驗證碼錯誤 返回上一頁重新填寫</button>
          */
        }

      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete,
    unloginAddItem: state.myFavorite.unloginAddItem
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onFetchMyFavorite: (memberId: string, addItem?: AddFavoriteItem) => dispatch(fetchMyFavorite(memberId, addItem)),
  onLogOut: () => dispatch(logOut()),
  setCaptchaErrorModalVisible: (visible: boolean) => dispatch(setCaptchaErrorModalVisibleAction(visible)),
  setCaptchaSendModalVisible: (visible: boolean) => dispatch(setCaptchaSendModalVisibleAction(visible)),
  setCaptchaReturnModalVisible: (visible: boolean) => dispatch(setCaptchaReturnModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(Signup);
